import { useContext } from "react";
import { ModalSettingContext } from "../../../../index";
import Select from "@UI/New/Select";
import { compareOptionsByLabel } from "@/helpers/new/compareOptionsByLabel";
import s from './index.module.css';
import { filterOptionsByLabel } from "@/helpers/new/filterOptionsByLabel";

export const SeminariansСlasses = () => {
    const { state, setFieldInState, courseSeminariansList, loadingCourseSeminarians} = useContext(ModalSettingContext);

    const fieldsSeminarian = {
        tokenSeparators: [','],
        mode: "multiple",
        loading: loadingCourseSeminarians,
        showSearch: true,
        allowClear: true,
        filterSort: compareOptionsByLabel,
        filterOption: filterOptionsByLabel,
        onChange: e => setFieldInState({field: 'seminariansСlasses', value: e }),
        options: courseSeminariansList,
        value: state.seminariansСlasses,
        placeholder: 'Список сотрудников на звонке',
        notFoundContent: !state.direction
            ? "Выберите курс" 
            : "Сотрудники не найдены" 
    };

    return (
        <Select 
            wrapperClassName={s.wrapperSelect} 
            className={s.select} 
            fields={fieldsSeminarian} 
        />
    );
};